module.exports = __webpack_public_path__ + "static/img/rotate.5f6a238.svg";